<p-menu
  #textSelectionMenu
  styleClass="text-xs w-auto"
  [style]="{ padding: 0 }"
  [model]="items"
  [popup]="true"
  appendTo="body"
/>

<div style="display: block; height: 100%">
  @if (viewer == 'pre') {
  <!-- <pre class="eml-frame" id="iframed" [innerHTML]="emlHtml | sanitizer"></pre> -->
    <iframe class="eml-frame" #emailFrame
    [style.height]="emlHeight"
    [srcdoc]="emlHtml" allowfullscreen height="100%"></iframe>
  }@else if (viewer == 'div') {
  <!-- <div class="eml-frame" id="iframed" [innerHTML]="emlHtml | sanitizer"></div> -->
    <iframe class="eml-frame" #emailFrame
    [style.height]="emlHeight"
    [srcdoc]="emlHtml" allowfullscreen height="100%"></iframe>
  }@else if (viewer == 'pdf') {
  <iframe
    [src]="emlHtml"
    allowfullscreen
    [width]="'100%'"
    [height]="'100%'"
    title="Email Content"
  ></iframe>
  } @else {
  <iframe
    class="eml-frame"
    #emailFrame
    [style.height]="emlHeight"
    [srcdoc]="emlHtml.toString() | sanitizer"
    allowfullscreen
    height="100%"
    title="Email Content"
    (load)="onLoad()"
  ></iframe>
  }
</div>
